// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host-context(.wdw) {
  /* WDW COLOR CODE */
  /* AULANI COLOR CODE */
  /**
   * variables.scss
   * Contains the sitewide variables
   */
  /**
   * Breakpoints variables
   */
  /**
   * Colors variables
   */
  /**
   * z-index variables
   */
  /**
   * function.scss
   * Contains the sitewide functions
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * global.scss
   * Contains the sitewide global styles
   */
  /**
   * reset.scss
   * Contains the sitewide css reset
   */
  --checkbox-icon-padding: 0;
}
:host-context(.wdw) * {
  background-repeat: no-repeat;
  box-sizing: border-box;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  position: relative;
  text-rendering: optimizeLegibility;
}
:host-context(.wdw) *:before, :host-context(.wdw) *:after {
  box-sizing: border-box;
}
:host-context(.wdw) *:focus {
  outline: 1px dotted #000;
}
:host-context(.wdw) html,
:host-context(.wdw) body {
  margin: 0;
  min-height: 100vh;
}
:host-context(.wdw) body {
  width: 100%;
}
:host-context(.wdw) img {
  width: 100%;
}
:host-context(.wdw) h1,
:host-context(.wdw) h2,
:host-context(.wdw) h3,
:host-context(.wdw) h4,
:host-context(.wdw) h5 {
  margin: 0;
}
:host-context(.wdw) h1,
:host-context(.wdw) h2,
:host-context(.wdw) h3,
:host-context(.wdw) h4,
:host-context(.wdw) h5,
:host-context(.wdw) h6,
:host-context(.wdw) span,
:host-context(.wdw) a,
:host-context(.wdw) li,
:host-context(.wdw) p,
:host-context(.wdw) input,
:host-context(.wdw) textarea {
  font-family: inherit;
}
:host-context(.wdw) .clearfix, :host-context(.wdw) .magic-band .page-section,
:host-context(.wdw) .magic-band-mod-flow .page-section {
  zoom: 1;
}
:host-context(.wdw) .clearfix:after, :host-context(.wdw) .magic-band .page-section:after,
:host-context(.wdw) .magic-band-mod-flow .page-section:after {
  clear: both;
}
:host-context(.wdw) .clearfix:after, :host-context(.wdw) .magic-band .page-section:after,
:host-context(.wdw) .magic-band-mod-flow .page-section:after, :host-context(.wdw) .clearfix:before, :host-context(.wdw) .magic-band .page-section:before,
:host-context(.wdw) .magic-band-mod-flow .page-section:before {
  content: " ";
  display: block;
  overflow: hidden;
  visibility: hidden;
  width: 0;
  height: 0;
}
:host-context(.wdw) .float-left, :host-context(.wdw) .magic-band .page-section .left-section,
:host-context(.wdw) .magic-band-mod-flow .page-section .left-section {
  float: left;
}
:host-context(.wdw) .float-right {
  float: right;
}
:host-context(.wdw) html,
:host-context(.wdw) body,
:host-context(.wdw) div,
:host-context(.wdw) span,
:host-context(.wdw) object,
:host-context(.wdw) iframe,
:host-context(.wdw) h1,
:host-context(.wdw) h2,
:host-context(.wdw) h3,
:host-context(.wdw) h4,
:host-context(.wdw) h5,
:host-context(.wdw) h6,
:host-context(.wdw) p,
:host-context(.wdw) blockquote,
:host-context(.wdw) pre,
:host-context(.wdw) abbr,
:host-context(.wdw) address,
:host-context(.wdw) address,
:host-context(.wdw) cite,
:host-context(.wdw) code,
:host-context(.wdw) del,
:host-context(.wdw) dfn,
:host-context(.wdw) em,
:host-context(.wdw) img,
:host-context(.wdw) ins,
:host-context(.wdw) kbd,
:host-context(.wdw) q,
:host-context(.wdw) samp,
:host-context(.wdw) small,
:host-context(.wdw) strong,
:host-context(.wdw) sub,
:host-context(.wdw) sup,
:host-context(.wdw) var,
:host-context(.wdw) b,
:host-context(.wdw) i,
:host-context(.wdw) dl,
:host-context(.wdw) dt,
:host-context(.wdw) dd,
:host-context(.wdw) ol,
:host-context(.wdw) ul,
:host-context(.wdw) li,
:host-context(.wdw) fieldset,
:host-context(.wdw) form,
:host-context(.wdw) label,
:host-context(.wdw) legend,
:host-context(.wdw) table,
:host-context(.wdw) caption,
:host-context(.wdw) tbody,
:host-context(.wdw) tfoot,
:host-context(.wdw) thead,
:host-context(.wdw) tr,
:host-context(.wdw) th,
:host-context(.wdw) td,
:host-context(.wdw) article,
:host-context(.wdw) aside,
:host-context(.wdw) canvas,
:host-context(.wdw) details,
:host-context(.wdw) figcaption,
:host-context(.wdw) figure,
:host-context(.wdw) footer,
:host-context(.wdw) header,
:host-context(.wdw) hgroup,
:host-context(.wdw) menu,
:host-context(.wdw) nav,
:host-context(.wdw) section,
:host-context(.wdw) summary,
:host-context(.wdw) time,
:host-context(.wdw) mark,
:host-context(.wdw) audio,
:host-context(.wdw) video {
  background: transparent;
  border: 0;
  font-size: 100%;
  margin: 0;
  outline: 0;
  padding: 0;
  vertical-align: baseline;
}
:host-context(.wdw) article,
:host-context(.wdw) aside,
:host-context(.wdw) details,
:host-context(.wdw) figcaption,
:host-context(.wdw) figure,
:host-context(.wdw) footer,
:host-context(.wdw) header,
:host-context(.wdw) hgroup,
:host-context(.wdw) img,
:host-context(.wdw) menu,
:host-context(.wdw) nav,
:host-context(.wdw) section {
  display: block;
}
:host-context(.wdw) ol,
:host-context(.wdw) ul {
  list-style: none;
}
:host-context(.wdw) blockquote,
:host-context(.wdw) q {
  quotes: none;
}
:host-context(.wdw) blockquote :before,
:host-context(.wdw) blockquote :after,
:host-context(.wdw) q :before,
:host-context(.wdw) q :after {
  content: none;
}
:host-context(.wdw) a {
  background: transparent;
  font-size: 100%;
  margin: 0;
  padding: 0;
  text-decoration: none;
  touch-action: manipulation;
  vertical-align: baseline;
}
:host-context(.wdw) table {
  border-collapse: collapse;
  border-spacing: 0;
}
:host-context(.wdw) hr {
  border: 0;
  display: block;
  height: 1px;
  margin: 1em 0;
  padding: 0;
}
:host-context(.wdw) input,
:host-context(.wdw) select {
  vertical-align: middle;
}
:host-context(.wdw) address {
  font-style: normal;
}
:host-context(.wdw) input::-ms-clear {
  display: none;
}
:host-context(.wdw) button {
  background: none;
  border: 0;
  padding: 0;
}
:host-context(.wdw) .aulani .room-ready-terms-and-conditions p a {
  font-weight: 600;
  color: #D04901;
}
:host-context(.wdw) .aulani .room-ready-terms-and-conditions.edit p a {
  color: #B73C00;
}
:host-context(.wdw) .magic-band .page-section {
  padding: 30px 10px 30px;
}
:host-context(.wdw) .magic-band .border-section {
  padding: 30px 0 0;
  margin: 0 10px 0;
  border-bottom: thin solid #D8D8D8;
}
:host-context(.wdw) .magic-band-mod-flow .page-section {
  padding: 16px 0 0;
}
:host-context(.wdw) .magic-band-mod-flow .page-section.expanded {
  padding: 30px 0 0;
}
:host-context(.wdw) .magic-band .page-section .left-section span,
:host-context(.wdw) .magic-band-mod-flow .page-section .left-section span {
  font-size: 21px;
  line-height: 21px;
  font-weight: 400;
  letter-spacing: 0;
  position: absolute;
  width: 30px;
  height: 30px;
  font-weight: 400;
  font-family: Peptasia-Miscellaneous;
  top: 2px;
  color: #253B56;
}
:host-context(.wdw) .magic-band .page-section .left-section h3,
:host-context(.wdw) .magic-band-mod-flow .page-section .left-section h3 {
  font-size: 16px;
  line-height: 28px;
  font-weight: 400;
  letter-spacing: 0;
  padding-left: 40px;
  color: #253B56;
  font-family: "InspireTWDCHeavy";
  font-weight: 700;
  letter-spacing: -0.01px;
}
:host-context(.wdw) .magic-band .page-section .left-section h3 _:default:not(:root:root), :host-context(.wdw) .magic-band .page-section .left-section h3.safari_only,
:host-context(.wdw) .magic-band-mod-flow .page-section .left-section h3 _:default:not(:root:root),
:host-context(.wdw) .magic-band-mod-flow .page-section .left-section h3.safari_only {
  font-family: "InspireTWDC";
  font-weight: 700;
}
:host-context(.wdw) .magic-band .page-section .left-section .content,
:host-context(.wdw) .magic-band-mod-flow .page-section .left-section .content {
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  letter-spacing: 0;
  color: #253B56;
  font-family: "InspireTWDCBook";
  margin-top: 2px;
  padding-left: 1px;
}
:host-context(.wdw) .magic-band .page-section .left-section .content .mb-decline,
:host-context(.wdw) .magic-band-mod-flow .page-section .left-section .content .mb-decline {
  margin-top: 10px;
  margin-left: -2px;
}
:host-context(.wdw) .magic-band .page-section .left-section .content .mb-decline wdpr-checkbox,
:host-context(.wdw) .magic-band-mod-flow .page-section .left-section .content .mb-decline wdpr-checkbox {
  display: inline-block;
  vertical-align: middle;
}
:host-context(.wdw) .magic-band .page-section .left-section .content .mb-decline span,
:host-context(.wdw) .magic-band-mod-flow .page-section .left-section .content .mb-decline span {
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  letter-spacing: 0;
  width: 100%;
  color: #253B56;
  font-family: "InspireTWDCBook";
  padding-left: 5px;
  display: inline-block;
  vertical-align: middle;
}
:host-context(.wdw) .magic-band .border-section,
:host-context(.wdw) .magic-band-mod-flow .border-section {
  padding: 30px 0 0;
  border-bottom: thin solid #D8D8D8;
}
:host-context(.wdw) .magic-band .page-section .left-section .content .mb-decline span {
  width: auto;
}
@media (min-width: 767px) {
  :host-context(.wdw) .magic-band .page-section {
    padding: 30px 40px 30px;
  }
  :host-context(.wdw) .magic-band .border-section {
    padding: 30px 0 0;
    margin: 0 40px 0;
    border-bottom: thin solid #D8D8D8;
  }
  :host-context(.wdw) .magic-band-mod-flow .page-section {
    padding: 16px 0 0;
  }
  :host-context(.wdw) .magic-band-mod-flow .page-section.expanded {
    padding: 30px 0 0;
  }
  :host-context(.wdw) .magic-band-mod-flow .border-section {
    padding: 30px 0 0;
    margin: 0;
    border-bottom: thin solid #D8D8D8;
  }
  :host-context(.wdw) .magic-band .page-section .left-section,
  :host-context(.wdw) .magic-band-mod-flow .page-section .left-section {
    width: calc(100% - 130px);
    padding-right: 28px;
    margin: 0;
    display: inline-block;
  }
  :host-context(.wdw) .magic-band .page-section .left-section h3,
  :host-context(.wdw) .magic-band-mod-flow .page-section .left-section h3 {
    padding-left: 40px;
  }
  :host-context(.wdw) .magic-band .page-section .left-section span,
  :host-context(.wdw) .magic-band-mod-flow .page-section .left-section span {
    width: 30px;
    height: 30px;
    font-size: 24px;
  }
  :host-context(.wdw) .magic-band .page-section .left-section .content,
  :host-context(.wdw) .magic-band-mod-flow .page-section .left-section .content {
    padding-left: 40px;
  }
}
@media (min-width: 1024px) {
  :host-context(.wdw) .magic-band-mod-flow .border-section {
    margin: 0;
  }
}

:host-context(.aulani) {
  /* WDW COLOR CODE */
  /* AULANI COLOR CODE */
  /**
   * variables.scss
   * Contains the sitewide variables
   */
  /**
   * Breakpoints variables
   */
  /**
   * Colors variables
   */
  /**
   * z-index variables
   */
  /**
   * function.scss
   * Contains the sitewide functions
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * mixins.scss
   * Contains the sitewide mixins
   */
  /**
   * global.scss
   * Contains the sitewide global styles
   */
  /**
   * reset.scss
   * Contains the sitewide css reset
   */
}
:host-context(.aulani) * {
  background-repeat: no-repeat;
  box-sizing: border-box;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  position: relative;
  text-rendering: optimizeLegibility;
}
:host-context(.aulani) *:before, :host-context(.aulani) *:after {
  box-sizing: border-box;
}
:host-context(.aulani) *:focus {
  outline: 1px dotted #000;
}
:host-context(.aulani) html,
:host-context(.aulani) body {
  margin: 0;
  min-height: 100vh;
}
:host-context(.aulani) body {
  width: 100%;
}
:host-context(.aulani) img {
  width: 100%;
}
:host-context(.aulani) h1,
:host-context(.aulani) h2,
:host-context(.aulani) h3,
:host-context(.aulani) h4,
:host-context(.aulani) h5 {
  margin: 0;
}
:host-context(.aulani) h1,
:host-context(.aulani) h2,
:host-context(.aulani) h3,
:host-context(.aulani) h4,
:host-context(.aulani) h5,
:host-context(.aulani) h6,
:host-context(.aulani) span,
:host-context(.aulani) a,
:host-context(.aulani) li,
:host-context(.aulani) p,
:host-context(.aulani) input,
:host-context(.aulani) textarea {
  font-family: inherit;
}
:host-context(.aulani) .clearfix, :host-context(.aulani) .magic-band .page-section,
:host-context(.wdw):host-context(.aulani) .magic-band-mod-flow .page-section {
  zoom: 1;
}
:host-context(.aulani) .clearfix:after, :host-context(.aulani) .magic-band .page-section:after,
:host-context(.wdw):host-context(.aulani) .magic-band-mod-flow .page-section:after {
  clear: both;
}
:host-context(.aulani) .clearfix:after, :host-context(.aulani) .magic-band .page-section:after,
:host-context(.wdw):host-context(.aulani) .magic-band-mod-flow .page-section:after, :host-context(.aulani) .clearfix:before, :host-context(.aulani) .magic-band .page-section:before,
:host-context(.wdw):host-context(.aulani) .magic-band-mod-flow .page-section:before {
  content: " ";
  display: block;
  overflow: hidden;
  visibility: hidden;
  width: 0;
  height: 0;
}
:host-context(.aulani) .float-left, :host-context(.aulani) .magic-band .page-section .left-section,
:host-context(.wdw):host-context(.aulani) .magic-band-mod-flow .page-section .left-section {
  float: left;
}
:host-context(.aulani) .float-right {
  float: right;
}
:host-context(.aulani) html,
:host-context(.aulani) body,
:host-context(.aulani) div,
:host-context(.aulani) span,
:host-context(.aulani) object,
:host-context(.aulani) iframe,
:host-context(.aulani) h1,
:host-context(.aulani) h2,
:host-context(.aulani) h3,
:host-context(.aulani) h4,
:host-context(.aulani) h5,
:host-context(.aulani) h6,
:host-context(.aulani) p,
:host-context(.aulani) blockquote,
:host-context(.aulani) pre,
:host-context(.aulani) abbr,
:host-context(.aulani) address,
:host-context(.aulani) address,
:host-context(.aulani) cite,
:host-context(.aulani) code,
:host-context(.aulani) del,
:host-context(.aulani) dfn,
:host-context(.aulani) em,
:host-context(.aulani) img,
:host-context(.aulani) ins,
:host-context(.aulani) kbd,
:host-context(.aulani) q,
:host-context(.aulani) samp,
:host-context(.aulani) small,
:host-context(.aulani) strong,
:host-context(.aulani) sub,
:host-context(.aulani) sup,
:host-context(.aulani) var,
:host-context(.aulani) b,
:host-context(.aulani) i,
:host-context(.aulani) dl,
:host-context(.aulani) dt,
:host-context(.aulani) dd,
:host-context(.aulani) ol,
:host-context(.aulani) ul,
:host-context(.aulani) li,
:host-context(.aulani) fieldset,
:host-context(.aulani) form,
:host-context(.aulani) label,
:host-context(.aulani) legend,
:host-context(.aulani) table,
:host-context(.aulani) caption,
:host-context(.aulani) tbody,
:host-context(.aulani) tfoot,
:host-context(.aulani) thead,
:host-context(.aulani) tr,
:host-context(.aulani) th,
:host-context(.aulani) td,
:host-context(.aulani) article,
:host-context(.aulani) aside,
:host-context(.aulani) canvas,
:host-context(.aulani) details,
:host-context(.aulani) figcaption,
:host-context(.aulani) figure,
:host-context(.aulani) footer,
:host-context(.aulani) header,
:host-context(.aulani) hgroup,
:host-context(.aulani) menu,
:host-context(.aulani) nav,
:host-context(.aulani) section,
:host-context(.aulani) summary,
:host-context(.aulani) time,
:host-context(.aulani) mark,
:host-context(.aulani) audio,
:host-context(.aulani) video {
  background: transparent;
  border: 0;
  font-size: 100%;
  margin: 0;
  outline: 0;
  padding: 0;
  vertical-align: baseline;
}
:host-context(.aulani) article,
:host-context(.aulani) aside,
:host-context(.aulani) details,
:host-context(.aulani) figcaption,
:host-context(.aulani) figure,
:host-context(.aulani) footer,
:host-context(.aulani) header,
:host-context(.aulani) hgroup,
:host-context(.aulani) img,
:host-context(.aulani) menu,
:host-context(.aulani) nav,
:host-context(.aulani) section {
  display: block;
}
:host-context(.aulani) ol,
:host-context(.aulani) ul {
  list-style: none;
}
:host-context(.aulani) blockquote,
:host-context(.aulani) q {
  quotes: none;
}
:host-context(.aulani) blockquote :before,
:host-context(.aulani) blockquote :after,
:host-context(.aulani) q :before,
:host-context(.aulani) q :after {
  content: none;
}
:host-context(.aulani) a {
  background: transparent;
  font-size: 100%;
  margin: 0;
  padding: 0;
  text-decoration: none;
  touch-action: manipulation;
  vertical-align: baseline;
}
:host-context(.aulani) table {
  border-collapse: collapse;
  border-spacing: 0;
}
:host-context(.aulani) hr {
  border: 0;
  display: block;
  height: 1px;
  margin: 1em 0;
  padding: 0;
}
:host-context(.aulani) input,
:host-context(.aulani) select {
  vertical-align: middle;
}
:host-context(.aulani) address {
  font-style: normal;
}
:host-context(.aulani) input::-ms-clear {
  display: none;
}
:host-context(.aulani) button {
  background: none;
  border: 0;
  padding: 0;
}
:host-context(.aulani) .aulani .room-ready-terms-and-conditions p a {
  font-weight: 600;
  color: #D04901;
}
:host-context(.aulani) .aulani .room-ready-terms-and-conditions.edit p a {
  color: #B73C00;
}
:host-context(.aulani) .magic-band {
  padding: 30px 20px 0;
  clear: both;
}
:host-context(.aulani) .magic-band .horizontal-line {
  background-image: radial-gradient(#918F8C 0%, #FFF 100%);
  height: 1px;
  margin: 0 0 30px;
}
:host-context(.aulani) .magic-band .page-section .left-section span {
  position: absolute;
  width: 30px;
  height: 30px;
  font-family: Peptasia-Miscellaneous;
  top: 0;
  color: #382613;
  font-weight: 700;
  font-size: 21px;
}
:host-context(.aulani) .magic-band .page-section .left-section h3 {
  font-size: 16px;
  line-height: 28px;
  font-weight: 700;
  letter-spacing: 0;
  color: #382613;
  font-family: "InspireTWDCHeavy";
  padding-left: 40px;
}
:host-context(.aulani) .magic-band .page-section .left-section h3 _:default:not(:root:root), :host-context(.aulani) .magic-band .page-section .left-section h3.safari_only {
  font-family: "InspireTWDC";
  font-weight: 700;
}
:host-context(.aulani) .magic-band .page-section .left-section .content {
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
  letter-spacing: 0;
  color: #382613;
  font-family: "InspireTWDCRoman";
  font-weight: 400;
  padding-left: 1px;
  margin-top: 15px;
}
@media (min-width: 767px) {
  :host-context(.aulani) .magic-band {
    padding: 40px 20px;
  }
  :host-context(.aulani) .magic-band .horizontal-line {
    background-image: none;
    border-bottom: thin solid #918F8C;
  }
  :host-context(.aulani) .magic-band .page-section .left-section {
    width: calc(100% - 198px);
  }
  :host-context(.aulani) .magic-band .page-section .left-section h3 {
    font-size: 18px;
  }
  :host-context(.aulani) .magic-band .page-section .left-section .content p {
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    letter-spacing: 0;
    color: #382613;
    font-family: "InspireTWDCRoman";
    font-weight: 400;
    padding-left: 40px;
    margin-top: 15px;
  }
}
@media (min-width: 992px) {
  :host-context(.aulani) .magic-band .horizontal-line {
    margin: -30px 0 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/magic-band/magic-band.component.scss","webpack://./src/assets/style/theme/index.scss","webpack://./src/assets/style/abstracts/variables.scss","webpack://./src/assets/style/abstracts/functions.scss","webpack://./src/assets/style/abstracts/mixins.scss","webpack://./src/assets/style/base/global.scss","webpack://./src/assets/style/base/reset.scss","webpack://./src/app/magic-band/magic-band.component.wdw.scss","webpack://./src/assets/style/base/font.scss","webpack://./src/app/magic-band/magic-band.component.aulani.scss"],"names":[],"mappings":"AAAA;ECAA,mBAAA;EAkBA,sBAAA;EClBA;;;IAAA;EAKA;;IAAA;EAgBA;;IAAA;EAQA;;IAAA;EC7BA;;;IAAA;ECAA;;;IAAA;EAAA;;;IAAA;ECEA;;;IAAA;ECFA;;;IAAA;ENGI,0BAAA;AAkCJ;AK9BA;EACI,4BAAA;EACA,sBAAA;EACA,kCAAA;EACA,mCAAA;EACA,kBAAA;EACA,kCAAA;ALgCJ;AK9BI;EAEI,sBAAA;AL+BR;AK5BI;EACI,wBAAA;AL8BR;AK1BA;;EAEI,SAAA;EACA,iBAAA;AL4BJ;AKzBA;EACI,WAAA;AL2BJ;AKxBA;EACI,WAAA;AL0BJ;AKvBA;;;;;EAKI,SAAA;ALyBJ;AKtBA;;;;;;;;;;;;EAYI,oBAAA;ALwBJ;AKrBA;;EACI,OAAA;ALwBJ;AKtBI;;EACI,WAAA;ALyBR;AKtBI;;;EAEI,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;ALyBR;AKrBA;;EACI,WAAA;ALwBJ;AKrBA;EACI,YAAA;ALuBJ;AMvGA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsEI,uBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;ANyGJ;AMtGA;;;;;;;;;;;;EAYI,cAAA;ANwGJ;AMrGA;;EAEI,gBAAA;ANuGJ;AMpGA;;EAEI,YAAA;ANsGJ;AMpGI;;;;EAEI,aAAA;ANwGR;AMpGA;EACI,uBAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;ANsGJ;AMnGA;EACI,yBAAA;EACA,iBAAA;ANqGJ;AMlGA;EACI,SAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;ANoGJ;AMjGA;;EAEI,sBAAA;ANmGJ;AMhGA;EACI,kBAAA;ANkGJ;AM9FI;EACI,aAAA;ANgGR;AM5FA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;AN8FJ;AMzFQ;EACI,gBAAA;EACA,cAAA;AN2FZ;AMvFY;EACI,cAAA;ANyFhB;AO3PI;EACI,uBAAA;AP6PR;AO1PI;EACI,iBAAA;EACA,gBAAA;EACA,iCNHS;AD+PjB;AOvPI;EACI,iBAAA;APyPR;AOvPQ;EACI,iBAAA;APyPZ;AO5OY;;EHZR,eGa0B;EHZ1B,iBGYgC;EHXhC,gBAH+C;EAI/C,iBAJqE;EGezD,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mCAAA;EACA,QAAA;EACA,cNnCS;ADqRzB;AO/OY;;EHvBR,eGwB0B;EHvB1B,iBGuBgC;EHtBhC,gBAH+C;EAI/C,iBAJqE;EG0BzD,kBAAA;EACA,cNzCS;EM0CT,+BC7CS;ED8CT,gBAAA;EACA,uBAAA;APqPhB;AOnPgB;;;EAEI,0BCvDD;EDwDC,gBAAA;APsPpB;AOlPY;;EHtCR,eGuC0B;EHtC1B,iBGsCgC;EHrChC,gBAH+C;EAI/C,iBAJqE;EGyCzD,cNvDS;EMwDT,8BC9DQ;ED+DR,eAAA;EACA,iBAAA;APwPhB;AOtPgB;;EACI,gBAAA;EACA,iBAAA;APyPpB;AOvPoB;;EACI,qBAAA;EACA,sBAAA;AP0PxB;AOvPoB;;EHtDhB,eGuDkC;EHtDlC,iBGsDwC;EHrDxC,gBAH+C;EAI/C,iBAJqE;EGyDjD,WAAA;EACA,cNxEC;EMyED,8BC/EA;EDgFA,iBAAA;EACA,qBAAA;EACA,sBAAA;AP6PxB;AOtPI;;EACI,iBAAA;EACA,iCNnFS;AD4UjB;AOrPA;EACI,WAAA;APuPJ;AOpPA;EAEQ;IACI,uBAAA;EPqPV;EOlPM;IACI,iBAAA;IACA,gBAAA;IACA,iCNpGK;EDwVf;EO/OM;IACI,iBAAA;EPiPV;EO/OU;IACI,iBAAA;EPiPd;EO7OM;IACI,iBAAA;IACA,SAAA;IACA,iCNpHK;EDmWf;EOxOU;;IACI,yBAAA;IACA,mBAAA;IACA,SAAA;IACA,qBAAA;EP2Od;EOzOc;;IACI,kBAAA;EP4OlB;EOzOc;;IACI,WAAA;IACA,YAAA;IACA,eAAA;EP4OlB;EOzOc;;IACI,kBAAA;EP4OlB;AACF;AOtOA;EAEQ;IACI,SAAA;EPuOV;AACF;;AAjYA;ECNA,mBAAA;EAkBA,sBAAA;EClBA;;;IAAA;EAKA;;IAAA;EAgBA;;IAAA;EAQA;;IAAA;EC7BA;;;IAAA;ECAA;;;IAAA;EAAA;;;IAAA;ECEA;;;IAAA;ECFA;;;IAAA;AN6aA;AKtaA;EACI,4BAAA;EACA,sBAAA;EACA,kCAAA;EACA,mCAAA;EACA,kBAAA;EACA,kCAAA;ALwaJ;AKtaI;EAEI,sBAAA;ALuaR;AKpaI;EACI,wBAAA;ALsaR;AKlaA;;EAEI,SAAA;EACA,iBAAA;ALoaJ;AKjaA;EACI,WAAA;ALmaJ;AKhaA;EACI,WAAA;ALkaJ;AK/ZA;;;;;EAKI,SAAA;ALiaJ;AK9ZA;;;;;;;;;;;;EAYI,oBAAA;ALgaJ;AK7ZA;;EACI,OAAA;ALgaJ;AK9ZI;;EACI,WAAA;ALiaR;AK9ZI;;;EAEI,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;ALiaR;AK7ZA;;EACI,WAAA;ALgaJ;AK7ZA;EACI,YAAA;AL+ZJ;AM/eA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsEI,uBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;ANifJ;AM9eA;;;;;;;;;;;;EAYI,cAAA;ANgfJ;AM7eA;;EAEI,gBAAA;AN+eJ;AM5eA;;EAEI,YAAA;AN8eJ;AM5eI;;;;EAEI,aAAA;ANgfR;AM5eA;EACI,uBAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;AN8eJ;AM3eA;EACI,yBAAA;EACA,iBAAA;AN6eJ;AM1eA;EACI,SAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;AN4eJ;AMzeA;;EAEI,sBAAA;AN2eJ;AMxeA;EACI,kBAAA;AN0eJ;AMteI;EACI,aAAA;ANweR;AMpeA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;ANseJ;AMjeQ;EACI,gBAAA;EACA,cAAA;ANmeZ;AM/dY;EACI,cAAA;ANiehB;ASloBA;EACI,oBAAA;EAmDA,WAAA;ATklBJ;ASnoBI;EACI,wDAAA;EACA,WAAA;EACA,gBAAA;ATqoBR;AS5nBY;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mCAAA;EACA,MAAA;EACA,cRCY;EQAZ,gBAAA;EACA,eAAA;AT8nBhB;AS3nBY;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cRTY;EQUZ,+BDlCS;ECmCT,kBAAA;AT6nBhB;AS3nBgB;EAEI,0BD3CD;EC4CC,gBAAA;AT4nBpB;ASxnBY;EL1BR,eK2B0B;EL1B1B,iBK0BgC;ELzBhC,gBAH+C;EAI/C,iBAJqE;EK6BzD,cRtBY;EQuBZ,+BD7CS;EC8CT,gBAAA;EACA,iBAAA;EACA,gBAAA;AT6nBhB;AStnBA;EACI;IACI,kBAAA;ETwnBN;EStnBM;IACI,sBAAA;IACA,iCR7CY;EDqqBtB;ESpnBU;IACI,yBAAA;ETsnBd;ESpnBc;IACI,eAAA;ETsnBlB;ESlnBkB;ILzDhB,eK0DkC;ILzDlC,iBKyDwC;ILxDxC,gBAH+C;IAI/C,iBAJqE;IK4DjD,cRrDI;IQsDJ,+BD5EC;IC6ED,gBAAA;IACA,kBAAA;IACA,gBAAA;ETunBtB;AACF;AShnBA;EAEQ;IACI,oBAAA;ETinBV;AACF","sourcesContent":[":host-context(.wdw) {\r\n    @import './magic-band.component.wdw';\r\n\r\n    --checkbox-icon-padding: 0;\r\n}\r\n\r\n:host-context(.aulani) {\r\n    @import './magic-band.component.aulani';\r\n}\r\n","/* WDW COLOR CODE */\r\n\r\n$page-background: #E8EDF0;\r\n$primary-color: #FFF;\r\n$primary-shadow: 0 0 4px 0 rgba(37, 59, 86, 0.5);\r\n$secondary-color: #0470AB;\r\n$wdw-primary-message-text-color: #78899E;\r\n$wdw-primary-text-color: #253B56;\r\n$wdw-h3-heading: #424B5A;\r\n$primary-border: thin solid #D8D8D8;\r\n$primary-wdw-link: #1994D7;\r\n$secondary-wdw-link: #1B96D5;\r\n$wdw-message-span: #130026;\r\n$wdw-pinmodal-shadow: 0 1px 5px 1px rgba(102, 102, 86, 0.5);\r\n$wdw-pinmodal-background: rgba(255, 255, 255, 0.9);\r\n$wdw-breadcrumbs-next-color: #73A4BF;\r\n$wdw-disabled-color: #BADFF3;\r\n\r\n/* AULANI COLOR CODE */\r\n$papaya-whitebg-color: #D04901;\r\n$papaya-greybg-color: #B73C00;\r\n$aulani-link-color: #B73C00;\r\n$primary-aulani-border: thin solid #918F8C;\r\n$aulani-border-color: #918F8C;\r\n$aulani-secondary-text-color: #867F77;\r\n$border-background: #FFF;\r\n$primary-aulani-link: #D04901;\r\n$secondary-aulani-link: #D24B00;\r\n$aulani-primary-text-color: #382613;\r\n$aulani-warm-grey-color: #69645E;\r\n$primary-info-text: #8294AA;\r\n$secondary-button-background: #F3EEE6;\r\n$radio-gradient-border: linear-gradient(90deg, #F7F7F7 2%, #D8D8D8 15%, #DBDBDB 89%, #FBFBFB 100%);\r\n$footer-gradient-border: linear-gradient(90deg, #F7F7F7 2%, #D8D8D8 14%, #DBDBDB 95%, #FBFBFB 100%);\r\n$aulani-hover-link: #B14308;\r\n$aulani-border: radial-gradient($aulani-border-color 0%, #FFF 100%);\r\n$aulani-pinmodal-shadow: 0 1px 5px 1px rgba(102, 102, 86, 0.5);\r\n$aulani-pinmodal-background: rgba(255, 255, 255, 0.9);\r\n$aulani-error-text: #5C4830;\r\n$error-label-color: #FF4605;\r\n$aulani-text-disabed-color: #EFB698;\r\n\r\n$default-button-border: #0079BC;\r\n$default-text-color: #00233C;\r\n$hover-button-border: #006096;\r\n$active-button-border: #083C5D;\r\n$disabled-button-border: #B7E4F7;\r\n","/**\r\n * variables.scss\r\n * Contains the sitewide variables\r\n */\r\n\r\n/**\r\n * Breakpoints variables\r\n */\r\n\r\n$breakpoints: (\r\n    x-small: 0,\r\n    mobile: 320px,\r\n    tablet: 768px,\r\n    desktop: 1024px\r\n);\r\n\r\n$orientations: (\r\n    portrait: portrait,\r\n    landscape: landscape\r\n);\r\n\r\n/**\r\n * Colors variables\r\n */\r\n\r\n$colors: (\r\n    'transparent': transparent,\r\n);\r\n\r\n/**\r\n * z-index variables\r\n */\r\n\r\n$zindex: (\r\n    'base': 1,\r\n    'menu': 2,\r\n    'overlay': 3,\r\n    'modal': 4,\r\n    'toast': 5\r\n);\r\n","/**\r\n * function.scss\r\n * Contains the sitewide functions\r\n */\r\n\r\n@function colors($color) {\r\n    @if not map-has-key($colors, $color) {\r\n        @warn 'No color found for `#{$color}`.';\r\n    }\r\n    \r\n    @return map-get($colors, $color);\r\n}\r\n\r\n@function zindex($layer) {\r\n    @if not map-has-key($zindex, $layer) {\r\n        @warn 'No z-index found for `#{$layer}`.';\r\n    }\r\n    \r\n    @return map-get($zindex, $layer);\r\n}\r\n","/**\r\n * mixins.scss\r\n * Contains the sitewide mixins\r\n */\r\n\r\n@mixin from-breakpoint($bp) {\r\n    @if ($bp == 'x-small') {\r\n        @content;\r\n    }\r\n    @else {\r\n        @if map-has-key($breakpoints, $bp) {\r\n            $list: map-get($breakpoints, $bp);\r\n            $bp: nth($list, 1);\r\n        }\r\n        \r\n        @media screen and (min-width: #{$bp}) {\r\n            @content;\r\n        }\r\n    }\r\n}\r\n\r\n@mixin font($font-size, $line-height, $font-weight:400, $letter-spacing: 0) {\r\n    font-size: $font-size;\r\n    line-height: $line-height;\r\n    font-weight: $font-weight;\r\n    letter-spacing: $letter-spacing;\r\n}\r\n\r\n@mixin host-block() {\r\n    :host {\r\n        display: block;\r\n    }\r\n}\r\n\r\n@mixin float-left() {\r\n    float: left;\r\n}\r\n\r\n@mixin float-right() {\r\n    float: right;\r\n}\r\n\r\n@mixin btn-link($btnColor: #B73C00, $hoverColor: #7C3813) {\r\n    color: $btnColor;\r\n    font-weight: 600;\r\n\r\n    &:hover {\r\n        color: $hoverColor;\r\n    }\r\n\r\n    &:focus {\r\n        color: $btnColor;\r\n        outline: 2px solid $btnColor;\r\n        outline-offset: 4px;\r\n    }\r\n}\r\n","@import '../abstracts/mixins';\r\n\r\n/**\r\n * global.scss\r\n * Contains the sitewide global styles\r\n */\r\n\r\n* {\r\n    background-repeat: no-repeat;\r\n    box-sizing: border-box;\r\n    -moz-osx-font-smoothing: grayscale;\r\n    -webkit-font-smoothing: antialiased;\r\n    position: relative;\r\n    text-rendering: optimizeLegibility;\r\n\r\n    &:before,\r\n    &:after {\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    &:focus {\r\n        outline: 1px dotted #000;\r\n    }\r\n}\r\n\r\nhtml,\r\nbody {\r\n    margin: 0;\r\n    min-height: 100vh;\r\n}\r\n\r\nbody {\r\n    width: 100%;\r\n}\r\n\r\nimg {\r\n    width: 100%;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5 {\r\n    margin: 0;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\nspan,\r\na,\r\nli,\r\np,\r\ninput,\r\ntextarea {\r\n    font-family: inherit;\r\n}\r\n\r\n.clearfix {\r\n    zoom: 1;\r\n\r\n    &:after {\r\n        clear: both;\r\n    }\r\n    \r\n    &:after,\r\n    &:before {\r\n        content: '\\0020';\r\n        display: block;\r\n        overflow: hidden;\r\n        visibility: hidden;\r\n        width: 0;\r\n        height: 0;\r\n    }\r\n}\r\n\r\n.float-left {\r\n    float: left;\r\n}\r\n\r\n.float-right {\r\n    float: right;\r\n}\r\n","/**\r\n * reset.scss\r\n * Contains the sitewide css reset\r\n */\r\n\r\nhtml,\r\nbody,\r\ndiv,\r\nspan,\r\nobject,\r\niframe,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\np,\r\nblockquote,\r\npre,\r\nabbr,\r\naddress,\r\naddress,\r\ncite,\r\ncode,\r\ndel,\r\ndfn,\r\nem,\r\nimg,\r\nins,\r\nkbd,\r\nq,\r\nsamp,\r\nsmall,\r\nstrong,\r\nsub,\r\nsup,\r\nvar,\r\nb,\r\ni,\r\ndl,\r\ndt,\r\ndd,\r\nol,\r\nul,\r\nli,\r\nfieldset,\r\nform,\r\nlabel,\r\nlegend,\r\ntable,\r\ncaption,\r\ntbody,\r\ntfoot,\r\nthead,\r\ntr,\r\nth,\r\ntd,\r\narticle,\r\naside,\r\ncanvas,\r\ndetails,\r\nfigcaption,\r\nfigure,\r\nfooter,\r\nheader,\r\nhgroup,\r\nmenu,\r\nnav,\r\nsection,\r\nsummary,\r\ntime,\r\nmark,\r\naudio,\r\nvideo {\r\n    background: colors('transparent');\r\n    border: 0;\r\n    font-size: 100%;\r\n    margin: 0;\r\n    outline: 0;\r\n    padding: 0;\r\n    vertical-align: baseline;\r\n}\r\n\r\narticle,\r\naside,\r\ndetails,\r\nfigcaption,\r\nfigure,\r\nfooter,\r\nheader,\r\nhgroup,\r\nimg,\r\nmenu,\r\nnav,\r\nsection {\r\n    display: block;\r\n}\r\n\r\nol,\r\nul {\r\n    list-style: none;\r\n}\r\n\r\nblockquote,\r\nq {\r\n    quotes: none;\r\n\r\n    :before,\r\n    :after {\r\n        content: none;\r\n    }\r\n}\r\n\r\na {\r\n    background: colors('transparent');\r\n    font-size: 100%;\r\n    margin: 0;\r\n    padding: 0;\r\n    text-decoration: none;\r\n    touch-action: manipulation;\r\n    vertical-align: baseline;\r\n}\r\n\r\ntable {\r\n    border-collapse: collapse;\r\n    border-spacing: 0;\r\n}\r\n\r\nhr {\r\n    border: 0;\r\n    display: block;\r\n    height: 1px;\r\n    margin: 1em 0;\r\n    padding: 0;\r\n}\r\n\r\ninput,\r\nselect {\r\n    vertical-align: middle;\r\n}\r\n\r\naddress {\r\n    font-style: normal;\r\n}\r\n\r\ninput {\r\n    &::-ms-clear {\r\n        display: none;\r\n    }\r\n}\r\n\r\nbutton {\r\n    background: none;\r\n    border: 0;\r\n    padding: 0;\r\n}\r\n\r\n.aulani {\r\n    .room-ready-terms-and-conditions {\r\n        p a {\r\n            font-weight: 600;\r\n            color: #D04901;\r\n        }\r\n\r\n        &.edit {\r\n            p a {\r\n                color: #B73C00;\r\n            }\r\n        }\r\n    }\r\n}\r\n","@import '../../assets/style/theme/index';\r\n@import '../../assets/style/base';\r\n@import '../../assets/style/base/font.scss';\r\n\r\n.magic-band {\r\n    .page-section {\r\n        padding: 30px 10px 30px;\r\n    }\r\n\r\n    .border-section {\r\n        padding: 30px 0 0;\r\n        margin: 0 10px 0;\r\n        border-bottom: $primary-border;\r\n    }\r\n}\r\n\r\n.magic-band-mod-flow {\r\n    .page-section {\r\n        padding: 16px 0 0;\r\n\r\n        &.expanded {\r\n            padding: 30px 0 0;\r\n        }\r\n    }\r\n}\r\n\r\n.magic-band,\r\n.magic-band-mod-flow {\r\n    .page-section {\r\n        @extend .clearfix;\r\n\r\n        .left-section {\r\n            @extend .float-left;\r\n\r\n            span {\r\n                @include font(21px, 21px);\r\n                position: absolute;\r\n                width: 30px;\r\n                height: 30px;\r\n                font-weight: 400;\r\n                font-family: Peptasia-Miscellaneous;\r\n                top: 2px;\r\n                color: $wdw-primary-text-color;\r\n            }\r\n\r\n            h3 {\r\n                @include font(16px, 28px);\r\n                padding-left: 40px;\r\n                color: $wdw-primary-text-color;\r\n                font-family: $inspiretwdc-heavy-font;\r\n                font-weight: 700;\r\n                letter-spacing: -0.01px;\r\n\r\n                _:default:not(:root:root),\r\n                &.safari_only {\r\n                    font-family: $inspiretwdc-font;\r\n                    font-weight: 700;\r\n                }\r\n            }\r\n\r\n            .content {\r\n                @include font(14px, 20px);\r\n                color: $wdw-primary-text-color;\r\n                font-family: $inspiretwdc-book-font;\r\n                margin-top: 2px;\r\n                padding-left: 1px;\r\n\r\n                .mb-decline {\r\n                    margin-top: 10px;\r\n                    margin-left: -2px;\r\n\r\n                    wdpr-checkbox {\r\n                        display: inline-block;\r\n                        vertical-align: middle;\r\n                    }\r\n\r\n                    span {\r\n                        @include font(14px, 20px);\r\n                        width: 100%;\r\n                        color: $wdw-primary-text-color;\r\n                        font-family: $inspiretwdc-book-font;\r\n                        padding-left: 5px;\r\n                        display: inline-block;\r\n                        vertical-align: middle;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .border-section {\r\n        padding: 30px 0 0;\r\n        border-bottom: $primary-border;\r\n    }\r\n}\r\n\r\n.magic-band .page-section .left-section .content .mb-decline span {\r\n    width: auto;\r\n}\r\n\r\n@media (min-width: 767px) {\r\n    .magic-band {\r\n        .page-section {\r\n            padding: 30px 40px 30px;\r\n        }\r\n\r\n        .border-section {\r\n            padding: 30px 0 0;\r\n            margin: 0 40px 0;\r\n            border-bottom: $primary-border;\r\n        }\r\n    }\r\n\r\n    .magic-band-mod-flow {\r\n        .page-section {\r\n            padding: 16px 0 0;\r\n\r\n            &.expanded {\r\n                padding: 30px 0 0;\r\n            }\r\n        }\r\n\r\n        .border-section {\r\n            padding: 30px 0 0;\r\n            margin: 0;\r\n            border-bottom: $primary-border;\r\n        }\r\n    }\r\n\r\n    .magic-band,\r\n    .magic-band-mod-flow {\r\n        .page-section {\r\n            .left-section {\r\n                width: calc(100% - 130px);\r\n                padding-right: 28px;\r\n                margin: 0;\r\n                display: inline-block;\r\n\r\n                h3 {\r\n                    padding-left: 40px;\r\n                }\r\n\r\n                span {\r\n                    width: 30px;\r\n                    height: 30px;\r\n                    font-size: 24px;\r\n                }\r\n\r\n                .content {\r\n                    padding-left: 40px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media (min-width: 1024px) {\r\n    .magic-band-mod-flow {\r\n        .border-section {\r\n            margin: 0;\r\n        }\r\n    }\r\n}\r\n","$inspiretwdc-font: 'InspireTWDC';\r\n$inspiretwdc-book-font: 'InspireTWDCBook';\r\n$inspiretwdc-light-font: 'InspireTWDCLight';\r\n$inspiretwdc-medium-font: 'InspireTWDCMedium';\r\n$inspiretwdc-heavy-font: 'InspireTWDCHeavy';\r\n$inspiretwdc-black-font: 'InspireTWDCBlack';\r\n$inspiretwdc-roman-font: 'InspireTWDCRoman';\r\n","//TODO UNCOMMENT THIS WHEN AULANI DK/XBMS IS ACTIVE (GFAM-46 on jira)\r\n\r\n@import '../../assets/style/theme/index';\r\n@import '../../assets/style/base';\r\n@import '../../assets/style/base/font.scss';\r\n\r\n.magic-band {\r\n    padding: 30px 20px 0;\r\n\r\n    .horizontal-line {\r\n        background-image: radial-gradient($aulani-border-color 0%, #FFF 100%);\r\n        height: 1px;\r\n        margin: 0 0 30px;\r\n    }\r\n\r\n    .page-section {\r\n        @extend .clearfix;\r\n\r\n        .left-section {\r\n            @extend .float-left;\r\n\r\n            span {\r\n                position: absolute;\r\n                width: 30px;\r\n                height: 30px;\r\n                font-family: Peptasia-Miscellaneous;\r\n                top: 0;\r\n                color: $aulani-primary-text-color;\r\n                font-weight: 700;\r\n                font-size: 21px;\r\n            }\r\n\r\n            h3 {\r\n                font-size: 16px;\r\n                line-height: 28px;\r\n                font-weight: 700;\r\n                letter-spacing: 0;\r\n                color: $aulani-primary-text-color;\r\n                font-family: $inspiretwdc-heavy-font;\r\n                padding-left: 40px;\r\n\r\n                _:default:not(:root:root),\r\n                &.safari_only {\r\n                    font-family: $inspiretwdc-font;\r\n                    font-weight: 700;\r\n                }\r\n            }\r\n\r\n            .content {\r\n                @include font(14px, 16px);\r\n                color: $aulani-primary-text-color;\r\n                font-family: $inspiretwdc-roman-font;\r\n                font-weight: 400;\r\n                padding-left: 1px;\r\n                margin-top: 15px;\r\n            }\r\n        }\r\n    }\r\n    clear: both;\r\n}\r\n\r\n@media (min-width: 767px) {\r\n    .magic-band {\r\n        padding: 40px 20px;\r\n\r\n        .horizontal-line {\r\n            background-image: none;\r\n            border-bottom: $primary-aulani-border;\r\n        }\r\n\r\n        .page-section {\r\n            .left-section {\r\n                width: calc(100% - 198px);\r\n\r\n                h3 {\r\n                    font-size: 18px;\r\n                }\r\n\r\n                .content {\r\n                    p {\r\n                        @include font(16px, 24px);\r\n                        color: $aulani-primary-text-color;\r\n                        font-family: $inspiretwdc-roman-font;\r\n                        font-weight: 400;\r\n                        padding-left: 40px;\r\n                        margin-top: 15px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n    .magic-band {\r\n        .horizontal-line {\r\n            margin: -30px 0 30px;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
